import React from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { CgMenu } from 'react-icons/cg';
import { FaClipboard, FaCopy, FaEdit, FaFileInvoiceDollar, FaTrash, FaReceipt } from 'react-icons/fa';
import Load from '../../../../models/load';
import classes from './LoadActionMenu.module.scss';

interface LoadActionMenuProps {
  load: Load;
  loadStatus: 'unassigned' | 'assigned' | 'completed' | 'plugged';
  userType: string;
  onDelete: () => void;
  onDuplicate: () => void;
  onComplete: () => void;
  onPlugLoad: () => void;
  onEdit: () => void;
  onShowCharges: () => void;
  onShowDocuments: () => void;
  onShowInvoicing: () => void;
  onUnComplete: (loadStatus: string) => void;
  onGenerateInvoice?: () => void;
  onClientInvoice?: () => void;
  onTrackLoad?: () => void;
  onPreAdviseDetails?: () => void;
}

const LoadActionMenu: React.FC<LoadActionMenuProps> = ({
  load,
  loadStatus,
  userType,
  onDelete,
  onDuplicate,
  onComplete,
  onPlugLoad,
  onEdit,
  onShowCharges,
  onShowDocuments,
  onUnComplete,
  onGenerateInvoice,
  onClientInvoice,
  onTrackLoad,
  onPreAdviseDetails
}) => {
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);

  if (userType === 'owner' && loadStatus !== 'completed' && loadStatus !== 'assigned') {
    return null;
  }

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
      <DropdownToggle className={classes.menuToggle}>
        <CgMenu />
      </DropdownToggle>
      <DropdownMenu className={classes.actionMenu} end container="body">
        {userType === 'admin' && (
          <DropdownItem onClick={onEdit}>
            <FaEdit className={classes.menuIcon} /> Edit
          </DropdownItem>
        )}

        {userType === 'admin' && (
          <DropdownItem onClick={onDelete}>
            <FaTrash className={classes.menuIcon} /> Delete
          </DropdownItem>
        )}

        {userType === 'admin' && loadStatus === 'unassigned' && (
          <DropdownItem onClick={onDuplicate}>
            <FaCopy className={classes.menuIcon} /> Duplicate
          </DropdownItem>
        )}

        {userType === 'admin' && loadStatus === 'assigned' && (
          <DropdownItem onClick={onComplete}>
            <FaClipboard className={classes.menuIcon} /> Complete
          </DropdownItem>
        )}

        {userType === 'admin' && loadStatus === 'assigned' && (
          <DropdownItem onClick={onPlugLoad}>
            <FaClipboard className={classes.menuIcon} /> Plug
          </DropdownItem>
        )}

        {userType === 'admin' && (loadStatus === 'completed' || loadStatus === 'plugged') && (
          <DropdownItem onClick={() => onUnComplete('assigned')}>
            <FaClipboard className={classes.menuIcon} /> Un-complete
          </DropdownItem>
        )}

        {(userType === 'admin' || (userType === 'owner' && loadStatus === 'completed')) && (
          <DropdownItem onClick={onShowCharges}>
            <FaFileInvoiceDollar className={classes.menuIcon} /> Charges
          </DropdownItem>
        )}
        {(userType === 'admin' || userType === 'client' || userType === 'packHouse' || userType === 'plugDepot' || userType === 'exporter' || (userType === 'owner' && (loadStatus === 'completed' || loadStatus === 'assigned'))) && (
          <DropdownItem onClick={onShowDocuments}>
            <FaClipboard className={classes.menuIcon} /> Documents
          </DropdownItem>
        )}

        {(userType === 'admin') && loadStatus === 'completed' && onGenerateInvoice && (
          <DropdownItem onClick={onGenerateInvoice}>
            <FaReceipt className={classes.menuIcon} /> {load.invoiceId ? 'View Invoice' : 'Generate Invoice'}
          </DropdownItem>
        )}

        {(userType === 'admin') && loadStatus === 'completed' && (
          <DropdownItem onClick={onClientInvoice}>
            <FaReceipt className={classes.menuIcon} /> Client Invoice
          </DropdownItem>
        )}

        {(userType === 'admin' || userType === 'client') && loadStatus === 'assigned' && (
          <DropdownItem onClick={onTrackLoad}>
            <FaClipboard className={classes.menuIcon} /> Track Load
          </DropdownItem>
        )}

        {(userType === 'admin' || userType === 'client') && (
          <DropdownItem onClick={onPreAdviseDetails}>
            <FaClipboard className={classes.menuIcon} /> Pre-advise details
          </DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export default LoadActionMenu;
